/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { toHeaderCase } from "js-convert-case";
import { GET_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";

const SERVICE_NAME = "AppNavigatorService.ProfileService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUserMethods extends IPluginMethodMap {
  getUserProfile(args: any): Promise<any>;
}

export class UserService implements IAgentPlugin {
  readonly methods: IUserMethods;

  constructor() {
    this.methods = {
      getUserProfile: this.getUserProfile.bind(this),
    };
  }

  async getUserProfile(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        if (res?.data?.getMyProfile) {
          return {
            userName: this.getUserName(res?.data?.getMyProfile),
            userImage: this.getUserImage(res?.data?.getMyProfile),
            userEmail: res?.data?.getMyProfile?.email,
            userId: res?.data?.getMyProfile?.id
          };
        }
      }
    } catch (err: any) {
      return {
        userName: "",
        userImage: "",
        userEmail: "",
        userId:""
      };
    }
  }

  private getUserName(data: any) {
    if (data?.firstName) {
      return `${toHeaderCase(data?.firstName)} ${toHeaderCase(
        data?.lastName ?? " "
      )}`;
    }
  }

  private getUserImage(data: any) {
    if (data?.image) {
      return data?.image;
    } else {
      return `https://ui-avatars.com/api/?name=${data?.firstName}+${data?.lastName}&background=0D8ABC&color=fff`;
    }
  }
}
